export enum RefererName {
  Tasks = 'Tasks',
  ChecklistTemplates = 'ChecklistTemplates'
}
